"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgCompass = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 2a1 1 0 1 0-2 0v1.145a3.502 3.502 0 0 0-1.549 5.753L5.43 15.823a11.073 11.073 0 0 1-1.68-1.547 1 1 0 1 0-1.5 1.323 13.068 13.068 0 0 0 2.17 1.964l-2.285 3.935a1 1 0 1 0 1.73 1.004l2.264-3.9A12.946 12.946 0 0 0 12 20c2.112 0 4.107-.504 5.87-1.398l2.265 3.9a1 1 0 0 0 1.73-1.004l-2.285-3.935a13.068 13.068 0 0 0 2.17-1.964 1 1 0 0 0-1.5-1.323 11.07 11.07 0 0 1-1.68 1.547L14.549 8.9A3.502 3.502 0 0 0 13 3.145V2Zm-1 8c.282 0 .557-.033.82-.097l4.044 6.966A10.954 10.954 0 0 1 12 18c-1.746 0-3.398-.407-4.864-1.131l4.044-6.966c.263.064.538.097.82.097Z", fill: "currentColor" }) }))); };
exports.default = SvgCompass;
